// Mail template imports
import { certificateExpiredTemplates } from './mail/certificateExpired';
import { certificateUpcomingExpirationTemplates } from './mail/certificateUpcomingExpiration';
import { companyInvoiceTemplates } from './mail/companyInvoice';
import { documentSignatureReminderTemplates } from './mail/documentSignatureReminder';
import { documentSignedTemplates } from './mail/documentSigned';
import { leaseAllowProfessionalActivityOnTemplates } from './mail/leaseAllowProfessionalActivityOn';
import { leaseBankingInfoUpdateTemplates } from './mail/leaseBankingInfoUpdate';
import { leaseChargesAdjustmentTemplates } from './mail/leaseChargesAdjustment';
import { leaseContractExtendedTemplates } from './mail/leaseContractExtended';
import { leaseContractRejectedTemplates } from './mail/leaseContractRejected';
import { leaseContractRetractedTemplates } from './mail/leaseContractRetracted';
import { leaseContractRevokedTemplates } from './mail/leaseContractRevoked';
import { leaseContractSignatureReminderTemplates } from './mail/leaseContractSignatureReminder';
import { leaseContractSignedTemplates } from './mail/leaseContractSigned';
import { leaseCreditNoteTemplates } from './mail/leaseCreditNote';
import { leaseDiscountCreatedTemplates } from './mail/leaseDiscountCreated';
import { leaseDiscountDeletedTemplates } from './mail/leaseDiscountDeleted';
import { leaseDiscountUpdatedTemplates } from './mail/leaseDiscountUpdated';
import { leaseOperationCreatedTemplates } from './mail/leaseOperationCreated';
import { leaseOperationDeletedTemplates } from './mail/leaseOperationDeleted';
import { leaseOperationPaymentRequestTemplates } from './mail/leaseOperationPaymentRequest';
import { leaseOperationUpdatedTemplates } from './mail/leaseOperationUpdated';
import { leasePaymentProviderMandateRequestTemplates } from './mail/leasePaymentProviderMandateRequest';
import { leasePaymentReceiptTemplates } from './mail/leasePaymentReceipt';
import { leasePaymentRequestTemplates } from './mail/leasePaymentRequest';
import { leaseRentalAdaptationTemplates } from './mail/leaseRentalAdaptation';
import { leaseRentIndexationTemplates } from './mail/leaseRentIndexation';
import { leaseRentIndexationSkippedTemplates } from './mail/leaseRentIndexationSkipped';
import { leaseSepaMandateFailedTemplates } from './mail/leaseSepaMandateFailed';
import { leaseSepaPaymentFailedTemplates } from './mail/leaseSepaPaymentFailed';
import { leaseSepaPredebitNoticeTemplates } from './mail/leaseSepaPredebitNotice';
import { leaseTenantStatementTemplates } from './mail/leaseTenantStatement';
import { leaseTerminationTemplates } from './mail/leaseTermination';
import { leaseUnpaidAmountFormalNoticeTemplates } from './mail/leaseUnpaidAmountFormalNotice';
import { leaseUnpaidAmountReminderTemplates } from './mail/leaseUnpaidAmountReminder';
import { leaseUnpaidAmountSecondReminderTemplates } from './mail/leaseUnpaidAmountSecondReminder';
import { leaseUnpaidAmountThirdReminderTemplates } from './mail/leaseUnpaidAmountThirdReminder';
import { leaseUnpaidConsolidatedPaymentReminderTemplates } from './mail/leaseUnpaidConsolidatedPaymentReminder';
import { ownerStatementTemplates } from './mail/ownerStatement';
import { certificateExpiredTemplates as smsCertificateExpiredTemplates } from './sms/certificateExpired';
import { certificateUpcomingExpirationTemplates as smsCertificateUpcomingExpirationTemplates } from './sms/certificateUpcomingExpiration';
import { leaseChargesAdjustmentTemplates as smsLeaseChargesAdjustmentTemplates } from './sms/leaseChargesAdjustment';
import { leaseContractExtendedTemplates as smsLeaseContractExtendedTemplates } from './sms/leaseContractExtended';
import { leaseContractSignatureReminderTemplates as smsLeaseContractSignatureReminderTemplates } from './sms/leaseContractSignatureReminder';
import { leaseContractSignedTemplates as smsLeaseContractSignedTemplates } from './sms/leaseContractSigned';
import { leaseCreditNoteTemplates as smsLeaseCreditNoteTemplates } from './sms/leaseCreditNote';
import { leaseDiscountCreatedTemplates as smsLeaseDiscountCreatedTemplates } from './sms/leaseDiscountCreated';
import { leaseDiscountDeletedTemplates as smsLeaseDiscountDeletedTemplates } from './sms/leaseDiscountDeleted';
import { leaseDiscountUpdatedTemplates as smsLeaseDiscountUpdatedTemplates } from './sms/leaseDiscountUpdated';
import { leaseOperationCreatedTemplates as smsLeaseOperationCreatedTemplates } from './sms/leaseOperationCreated';
import { leaseOperationDeletedTemplates as smsLeaseOperationDeletedTemplates } from './sms/leaseOperationDeleted';
import { leaseOperationPaymentRequestTemplates as smsLeaseOperationPaymentRequestTemplates } from './sms/leaseOperationPaymentRequest';
import { leaseOperationUpdatedTemplates as smsLeaseOperationUpdatedTemplates } from './sms/leaseOperationUpdated';
import { leasePaymentRequestTemplates as smsLeasePaymentRequestTemplates } from './sms/leasePaymentRequest';
import { leaseRentalAdaptationTemplates as smsLeaseRentalAdaptationTemplates } from './sms/leaseRentalAdaptation';
import { leaseRentIndexationTemplates as smsLeaseRentIndexationTemplates } from './sms/leaseRentIndexation';
import { leaseRentIndexationSkippedTemplates as smsLeaseRentIndexationSkippedTemplates } from './sms/leaseRentIndexationSkipped';
import { leaseTenantStatementTemplates as smsLeaseTenantStatementTemplates } from './sms/leaseTenantStatement';
import { leaseUnpaidAmountReminderTemplates as smsLeaseUnpaidAmountReminderTemplates } from './sms/leaseUnpaidAmountReminder';
import { leaseUnpaidAmountSecondReminderTemplates as smsLeaseUnpaidAmountSecondReminderTemplates } from './sms/leaseUnpaidAmountSecondReminder';
import { leaseUnpaidAmountThirdReminderTemplates as smsLeaseUnpaidAmountThirdReminderTemplates } from './sms/leaseUnpaidAmountThirdReminder';
import { leaseUnpaidConsolidatedPaymentReminderTemplates as smsLeaseUnpaidConsolidatedPaymentReminderTemplates } from './sms/leaseUnpaidConsolidatedPaymentReminder';
import { leaseChargesAdjustmentTemplates as whatsappLeaseChargesAdjustmentTemplates } from './whatsapp/leaseChargesAdjustment';
import { leaseContractExtendedTemplates as whatsappLeaseContractExtendedTemplates } from './whatsapp/leaseContractExtended';
import { leaseContractSignatureReminderTemplates as whatsappLeaseContractSignatureReminderTemplates } from './whatsapp/leaseContractSignatureReminder';
import { leaseContractSignedTemplates as whatsappLeaseContractSignedTemplates } from './whatsapp/leaseContractSigned';
import { leaseCreditNoteTemplates as whatsappLeaseCreditNoteTemplates } from './whatsapp/leaseCreditNote';
import { leaseDiscountCreatedTemplates as whatsappLeaseDiscountCreatedTemplates } from './whatsapp/leaseDiscountCreated';
import { leaseDiscountDeletedTemplates as whatsappLeaseDiscountDeletedTemplates } from './whatsapp/leaseDiscountDeleted';
import { leaseDiscountUpdatedTemplates as whatsappLeaseDiscountUpdatedTemplates } from './whatsapp/leaseDiscountUpdated';
import { leaseOperationCreatedTemplates as whatsappLeaseOperationCreatedTemplates } from './whatsapp/leaseOperationCreated';
import { leaseOperationDeletedTemplates as whatsappLeaseOperationDeletedTemplates } from './whatsapp/leaseOperationDeleted';
import { leaseOperationPaymentRequestTemplates as whatsappLeaseOperationPaymentRequestTemplates } from './whatsapp/leaseOperationPaymentRequest';
import { leaseOperationUpdatedTemplates as whatsappLeaseOperationUpdatedTemplates } from './whatsapp/leaseOperationUpdated';
import { leasePaymentRequestTemplates as whatsappLeasePaymentRequestTemplates } from './whatsapp/leasePaymentRequest';
import { leaseRentalAdaptationTemplates as whatsappLeaseRentalAdaptationTemplates } from './whatsapp/leaseRentalAdaptation';
import { leaseRentIndexationTemplates as whatsappLeaseRentIndexationTemplates } from './whatsapp/leaseRentIndexation';
import { leaseRentIndexationSkippedTemplates as whatsappLeaseRentIndexationSkippedTemplates } from './whatsapp/leaseRentIndexationSkipped';
import { leaseTenantStatementTemplates as whatsappLeaseTenantStatementTemplates } from './whatsapp/leaseTenantStatement';
import { leaseUnpaidAmountReminderTemplates as whatsappLeaseUnpaidAmountReminderTemplates } from './whatsapp/leaseUnpaidAmountReminder';
import { leaseUnpaidAmountSecondReminderTemplates as whatsappLeaseUnpaidAmountSecondReminderTemplates } from './whatsapp/leaseUnpaidAmountSecondReminder';
import { leaseUnpaidAmountThirdReminderTemplates as whatsappLeaseUnpaidAmountThirdReminderTemplates } from './whatsapp/leaseUnpaidAmountThirdReminder';
import { leaseUnpaidConsolidatedPaymentReminderTemplates as whatsappLeaseUnpaidConsolidatedPaymentReminderTemplates } from './whatsapp/leaseUnpaidConsolidatedPaymentReminder';

/**
 * Here we define the base IDs for each template type.
 * These IDs are used to identify the templates in the system.
 * -1 = mail, -2 = sms, -3 = whatsapp, -9 = contract, -8 = header/footer
 * 001 = EN, 002 = FR, 003 = NL, 004 = DE
 * TemplateBaseIds = {
  documentSignatureReminder: '-x00xxx',
  documentSigned: '-x01xxx',
  leaseAllowProfessionalActivityOn: '-x02xxx',
  leaseBankingInfoUpdate: '-x03xxx',
  leaseChargesAdjustment: '-x04xxx',
  leaseContractExtended: '-x05xxx',
  leaseContractRejected: '-x06xxx',
  leaseContractRetracted: '-x07xxx',
  leaseContractRevoked: '-x08xxx',
  leaseContractSignatureReminder: '-x09xxx',
  leaseContractSigned: '-x10xxx',
  leaseCreditNote: '-x11xxx',
  leaseDiscountCreated: '-x12xxx',
  leaseDiscountDeleted: '-x13xxx',
  leaseDiscountUpdated: '-x14xxx',
  leaseOperationCreated: '-x15xxx',
  leaseOperationDeleted: '-x16xxx',
  leaseOperationPaymentRequest: '-x17xxx',
  leaseOperationUpdated: '-x18xxx',
  leasePaymentProviderMandateRequest: '-x31xxx',
  leasePaymentReceipt: '-x19xxx',
  leasePaymentRequest: '-x20xxx',
  leaseRentIndexation: '-x21xxx',
  leaseRentIndexationSkipped: '-x22xxx',
  leaseRentalAdaptation: '-x23xxx',
  leaseTenantStatement: '-x24xxx',
  leaseTermination: '-x25xxx',
  leaseUnpaidAmountFormalNotice: '-x26xxx',
  leaseUnpaidAmountReminder: '-x27xxx',
  leaseUnpaidAmountSecondReminder: '-x28xxx',
  leaseUnpaidConsolidatedPaymentReminder: '-x29xxx',
  ownerStatement: '-x30xxx',
};
 */

// Export all mail templates as a consolidated array
export const defaultMailTemplates = [
  ...documentSignatureReminderTemplates,
  ...documentSignedTemplates,
  ...leaseAllowProfessionalActivityOnTemplates,
  ...leaseBankingInfoUpdateTemplates,
  ...leaseChargesAdjustmentTemplates,
  ...leaseContractExtendedTemplates,
  ...leaseContractRejectedTemplates,
  ...leaseContractRetractedTemplates,
  ...leaseContractRevokedTemplates,
  ...leaseContractSignatureReminderTemplates,
  ...leaseContractSignedTemplates,
  ...leaseCreditNoteTemplates,
  ...leaseDiscountCreatedTemplates,
  ...leaseDiscountDeletedTemplates,
  ...leaseDiscountUpdatedTemplates,
  ...leaseOperationCreatedTemplates,
  ...leaseOperationDeletedTemplates,
  ...leaseOperationPaymentRequestTemplates,
  ...leaseOperationUpdatedTemplates,
  ...leasePaymentProviderMandateRequestTemplates,
  ...leasePaymentReceiptTemplates,
  ...leasePaymentRequestTemplates,
  ...leaseRentIndexationTemplates,
  ...leaseRentIndexationSkippedTemplates,
  ...leaseRentalAdaptationTemplates,
  ...leaseSepaPredebitNoticeTemplates,
  ...leaseSepaPaymentFailedTemplates,
  ...leaseSepaMandateFailedTemplates,
  ...leaseTenantStatementTemplates,
  ...leaseTerminationTemplates,
  ...leaseUnpaidAmountFormalNoticeTemplates,
  ...leaseUnpaidAmountReminderTemplates,
  ...leaseUnpaidAmountSecondReminderTemplates,
  ...leaseUnpaidAmountThirdReminderTemplates,
  ...leaseUnpaidConsolidatedPaymentReminderTemplates,
  ...ownerStatementTemplates,
  ...companyInvoiceTemplates,
  ...certificateExpiredTemplates,
  ...certificateUpcomingExpirationTemplates,
];

// Export all SMS templates as a consolidated array
export const defaultSMSTemplates = [
  ...smsLeaseChargesAdjustmentTemplates,
  ...smsLeaseContractExtendedTemplates,
  ...smsLeaseContractSignatureReminderTemplates,
  ...smsLeaseContractSignedTemplates,
  ...smsLeaseCreditNoteTemplates,
  ...smsLeaseDiscountCreatedTemplates,
  ...smsLeaseDiscountDeletedTemplates,
  ...smsLeaseDiscountUpdatedTemplates,
  ...smsLeaseOperationCreatedTemplates,
  ...smsLeaseOperationDeletedTemplates,
  ...smsLeaseOperationPaymentRequestTemplates,
  ...smsLeaseOperationUpdatedTemplates,
  ...smsLeasePaymentRequestTemplates,
  ...smsLeaseRentIndexationTemplates,
  ...smsLeaseRentIndexationSkippedTemplates,
  ...smsLeaseRentalAdaptationTemplates,
  ...smsLeaseTenantStatementTemplates,
  ...smsLeaseUnpaidAmountReminderTemplates,
  ...smsLeaseUnpaidAmountSecondReminderTemplates,
  ...smsLeaseUnpaidAmountThirdReminderTemplates,
  ...smsLeaseUnpaidConsolidatedPaymentReminderTemplates,
  ...smsCertificateExpiredTemplates,
  ...smsCertificateUpcomingExpirationTemplates,
];

// Export all WhatsApp templates as a consolidated array
export const defaultWhatsAppTemplates = [
  ...whatsappLeaseChargesAdjustmentTemplates,
  ...whatsappLeaseContractExtendedTemplates,
  ...whatsappLeaseContractSignatureReminderTemplates,
  ...whatsappLeaseContractSignedTemplates,
  ...whatsappLeaseCreditNoteTemplates,
  ...whatsappLeaseDiscountCreatedTemplates,
  ...whatsappLeaseDiscountDeletedTemplates,
  ...whatsappLeaseDiscountUpdatedTemplates,
  ...whatsappLeaseOperationCreatedTemplates,
  ...whatsappLeaseOperationDeletedTemplates,
  ...whatsappLeaseOperationPaymentRequestTemplates,
  ...whatsappLeaseOperationUpdatedTemplates,
  ...whatsappLeasePaymentRequestTemplates,
  ...whatsappLeaseRentIndexationTemplates,
  ...whatsappLeaseRentIndexationSkippedTemplates,
  ...whatsappLeaseRentalAdaptationTemplates,
  ...whatsappLeaseTenantStatementTemplates,
  ...whatsappLeaseUnpaidAmountReminderTemplates,
  ...whatsappLeaseUnpaidAmountSecondReminderTemplates,
  ...whatsappLeaseUnpaidAmountThirdReminderTemplates,
  ...whatsappLeaseUnpaidConsolidatedPaymentReminderTemplates,
];
